import React from 'react'
import {Button} from "@material-ui/core";
import {BookingMetrica} from "../metrika/booking";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

export const BookingHeader =
    ({
         buttonText,
         buttonCallback,
         appUrlSuffix = '',
         backButtonUrl = '',
         backButtonText = '',
         useLogoUrl = true,
         additionalMetrikaId = null,
     }) => (
        <div className="booking-header">
            {
                process.env.NODE_ENV !== 'development' ?
                    <BookingMetrica additionalMetrikaId={additionalMetrikaId} className="header-metrika-main-div"/>
                    : ''
            }
            {
                backButtonUrl ?
                    <div className="header-navigate">
                        <a href={backButtonUrl}>
                            <ArrowBackIosIcon/>
                            <span>{backButtonText ? backButtonText : 'Назад'}</span>
                        </a>
                    </div>
                    : ''
            }
            <div className="header-main">
                {
                    useLogoUrl ?
                        <a href={`https://app.tonesky.ru/${appUrlSuffix}`} target="_blank" rel="noopener noreferrer">
                            <div className="logo">
                                <img alt="logo-booking"
                                     src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + '/images/logo_booking_small.png'}/>
                                <div>TONESKY booking</div>
                            </div>
                        </a>
                        :
                        <div className="logo">
                            <img alt="logo-booking"
                                 src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + '/images/logo_booking_small.png'}/>
                            <div>TONESKY booking</div>
                        </div>
                }
                {buttonText && buttonCallback ?
                    <div>
                        <Button onClick={buttonCallback}>{buttonText}</Button>
                    </div>
                    : ''
                }
            </div>
        </div>
    );



